import React, { useEffect, useState } from "react";
import api, { money } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";
import { toast } from "sonner";
import { Plus, X } from "lucide-react";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get("/admin/coupons").then(r => setCoupons(r.data));
  useEffect(() => { load(); }, []);
  const save = async () => {
    const p = { ...edit, value: Number(edit.value), min_order: Number(edit.min_order || 0), max_discount: Number(edit.max_discount || 0) };
    if (p.id) await api.put(`/admin/coupons/${p.id}`, p); else await api.post("/admin/coupons", p);
    toast.success("Saved"); setEdit(null); load();
  };
  const del = async (c) => { if (!window.confirm("Delete?")) return; await api.delete(`/admin/coupons/${c.id}`); load(); };
  return (
    <div>
      <AdminHeader title="Coupons" action={<button onClick={() => setEdit({ code: "", type: "percent", value: 10, min_order: 0, max_discount: 0, active: true, description: "" })} className="btn-primary flex items-center gap-2"><Plus size={15} /> New Coupon</button>} />
      <div className="bg-white border border-sage/30 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-sage/30 text-left text-forest/50 text-xs uppercase"><th className="p-3">Code</th><th className="p-3">Type</th><th className="p-3">Value</th><th className="p-3">Min Order</th><th className="p-3">Used</th><th className="p-3">Status</th><th className="p-3"></th></tr></thead>
          <tbody>
            {coupons.map((c) => (
              <tr key={c.id} className="border-b border-sage/15">
                <td className="p-3 font-medium">{c.code}</td><td className="p-3">{c.type}</td>
                <td className="p-3">{c.type === "percent" ? `${c.value}%` : money(c.value)}</td>
                <td className="p-3">{money(c.min_order)}</td><td className="p-3">{c.used || 0}</td>
                <td className="p-3"><span className={`text-xs px-2 py-1 ${c.active ? "bg-moss/20 text-moss" : "bg-beige text-forest/50"}`}>{c.active ? "Active" : "Inactive"}</span></td>
                <td className="p-3"><button onClick={() => setEdit(c)} className="text-xs underline mr-2">Edit</button><button onClick={() => del(c)} className="text-xs underline text-brown">Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <div className="fixed inset-0 z-[80]"><div className="absolute inset-0 bg-forest/40" onClick={() => setEdit(null)} />
          <div className="absolute right-0 top-0 bottom-0 w-full max-w-md bg-ivory p-6 overflow-auto">
            <div className="flex justify-between mb-6"><h2 className="serif text-3xl">Coupon</h2><button onClick={() => setEdit(null)}><X size={22} /></button></div>
            <div className="space-y-4">
              <I label="Code" v={edit.code} on={(v) => setEdit({ ...edit, code: v.toUpperCase() })} testid="coupon-code" />
              <div><label className="text-xs uppercase text-forest/55">Type</label><select className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white" value={edit.type} onChange={(e) => setEdit({ ...edit, type: e.target.value })}><option value="percent">Percent</option><option value="flat">Flat</option></select></div>
              <I label="Value" type="number" v={edit.value} on={(v) => setEdit({ ...edit, value: v })} />
              <I label="Min order (₹)" type="number" v={edit.min_order} on={(v) => setEdit({ ...edit, min_order: v })} />
              <I label="Max discount (₹, 0 = none)" type="number" v={edit.max_discount} on={(v) => setEdit({ ...edit, max_discount: v })} />
              <I label="Description" v={edit.description} on={(v) => setEdit({ ...edit, description: v })} />
              <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={!!edit.active} onChange={(e) => setEdit({ ...edit, active: e.target.checked })} className="accent-forest" /> Active</label>
              <button onClick={save} className="btn-primary w-full" data-testid="coupon-save">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const I = ({ label, v, on, type = "text", testid }) => <div><label className="text-xs uppercase text-forest/55">{label}</label><input type={type} value={v ?? ""} onChange={(e) => on(e.target.value)} data-testid={testid} className="w-full border border-sage/40 px-3 py-2 mt-1 rounded-sm bg-white text-sm" /></div>;
